export default __webpack_public_path__ + "static/media/case_upload.6e41cb7e.png";